import Accordion from "@/components/Accordion";
import React from "react";
import { Branding } from "./Branding";
import { Layout } from "./Layout";
import { EyeCatcher } from "./EyeCatcher";
import { Header } from "./Header";
import { WelcomeMessage } from "./WelcomeMessage";
import { Footer } from "./Footer";
import { OfflineStatus } from "./OfflineStatus";
import { InQueueStatus } from "./InQueueStatus";
import ChatWindowPreview from "../../Preview/ChatWindowPreview";
import { ChatWindow } from "../../types";

interface Props {
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
  setStagedLogoFile: (file: File | null) => void;
  setStagedGraphicFile: (file: File | null) => void;
}

export default function Appearance(props: Props) {
  const [selectedScreen, setSelectedScreen] = React.useState("Landing");

  const previewScreens = [
    {
      label: "Landing Screen",
      action: () => setSelectedScreen("Landing"),
      name: "Landing"
    },
    // {
    //   label: "Initial Conversation",
    //   action: () => setSelectedScreen("initialConversation")
    // },
    {
      label: "Conversation List",
      action: () => setSelectedScreen("ConvoList"),
      name: "ConvoList"
    },
    {
      label: "Active Conversation",
      action: () => setSelectedScreen("Conversation"),
      name: "Conversation"
    },
    // {
    //   label: "Pre Chat Survey",
    //   action: () => setSelectedScreen("preChatSurvey")
    // },
    // {
    //   label: "Post Chat Survey",
    //   action: () => setSelectedScreen("postChatSurvey")
    // },
    // {
    //   label: "Offline Status",
    //   action: () => setSelectedScreen("offlineStatus")
    // },
    {
      label: "Waiting",
      action: () => setSelectedScreen("Connecting"),
      name: "Connecting"
    }
    // {
    //   label: "Eye Catcher",
    //   action: () => setSelectedScreen("eyeCatcher")
    // }
  ];

  return (
    <div className="panel flex bg-white rounded-2xl shadow-md w-full border">
      <div className="p-6 border-r border-slate-300 w-full">
        <div className="text-lg font-medium mb-2">Appearance</div>
        <div className="text-sm font-normal text-slate-600 mb-4">
          Customize the style configuration of your chat window
        </div>
        <div className="overflow-auto">
          <Accordion>
            <Branding
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
              setStagedLogoFile={props.setStagedLogoFile}
            />
            <Layout
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            {/* <EyeCatcher onExpanded={() => {}} /> */}
            <Header
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            <WelcomeMessage
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            <Footer
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            <OfflineStatus
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
            />
            <InQueueStatus
              onExpanded={() => {}}
              workingChatWindow={props.workingChatWindow}
              setWorkingChatWindow={props.setWorkingChatWindow}
              setStagedGraphicFile={props.setStagedGraphicFile}
            />
          </Accordion>
        </div>
      </div>
      <div className="w-full">
        <ChatWindowPreview
          chatWindow={props.workingChatWindow}
          previewScreens={previewScreens}
          selectedScreen={selectedScreen}
          setSelectedScreen={setSelectedScreen}
        />
      </div>
    </div>
  );
}
